import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { CartProvider } from "./context/CartContext";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import OrderSuccess from "./pages/OrderSuccess";
import Wholesale from "./pages/Wholesale";
import Sourcing from "./pages/Sourcing";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminApp from "./pages/admin/AdminApp";

function Layout({ children }) {
  const loc = useLocation();
  const hideNav = loc.pathname.startsWith("/admin/login");
  return (
    <>
      {!hideNav && <Navbar />}
      {children}
      {!hideNav && !loc.pathname.startsWith("/admin") && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home/>} />
              <Route path="/shop" element={<Shop/>} />
              <Route path="/shop/:slug" element={<ProductDetail/>} />
              <Route path="/cart" element={<Cart/>} />
              <Route path="/order-success" element={<OrderSuccess/>} />
              <Route path="/wholesale" element={<Wholesale/>} />
              <Route path="/our-sourcing" element={<Sourcing/>} />
              <Route path="/contact" element={<Contact/>} />
              <Route path="/admin/login" element={<AdminLogin/>} />
              <Route path="/admin/*" element={<AdminApp/>} />
            </Routes>
          </Layout>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}
